export default __webpack_public_path__ + "fcddd85.png";